export const locationData = {
  "Western": {
    "Colombo": ["Colombo 01-15", "Dehiwala", "Mount Lavinia", "Moratuwa", "Maharagama", "Nugegoda", "Kotte", "Battaramulla", "Malabe", "Hanwella", "Homagama", "Avissawella"],
    "Gampaha": ["Negombo", "Gampaha", "Veyangoda", "Kadawatha", "Kiribathgoda", "Ragama", "Ja-Ela", "Wattala", "Katunayake", "Minuwangoda", "Mirigama"],
    "Kalutara": ["Kalutara", "Panadura", "Horana", "Matugama", "Aluthgama", "Beruwala", "Ingiriya", "Wadduwa", "Bandaragama"]
  },
  "Central": {
    "Kandy": ["Kandy", "Peradeniya", "Gampola", "Nawalapitiya", "Katugastota", "Kundasale", "Watategama", "Gelioya", "Kadugannawa"],
    "Matale": ["Matale", "Dambulla", "Sigiriya", "Ukuwela", "Rattota", "Naula", "Galewela"],
    "Nuwara Eliya": ["Nuwara Eliya", "Hatton", "Talawakele", "Hanguranketa", "Ginigathena", "Walapane", "Agarapathana"]
  },
  "Southern": {
    "Galle": ["Galle", "Hikkaduwa", "Ambalangoda", "Karapitiya", "Baddegama", "Bentota", "Ahangama", "Elpitiya"],
    "Matara": ["Matara", "Weligama", "Akuressa", "Deniyaya", "Dickwella", "Kamburupitiya", "Hakmana"],
    "Hambantota": ["Hambantota", "Tangalle", "Beliatta", "Ambalantota", "Tissamaharama", "Walasmulla", "Middeniya"]
  },
  "Northern": {
    "Jaffna": ["Jaffna", "Chavakachcheri", "Point Pedro", "Karainagar", "Nallur", "Chankanai", "Kopay"],
    "Kilinochchi": ["Kilinochchi", "Pallai", "Poonakary", "Paranthan"],
    "Mannar": ["Mannar", "Madhu", "Nanattan", "Murunkan"],
    "Vavuniya": ["Vavuniya", "Cheddikulam", "Nedunkeni"],
    "Mullaitivu": ["Mullaitivu", "Oddusuddan", "Puthukkudiyiruppu", "Mulliyawalai"]
  },
  "Eastern": {
    "Batticaloa": ["Batticaloa", "Kattankudy", "Eravur", "Valaichchenai", "Kaluwanchikudy"],
    "Ampara": ["Ampara", "Kalmunai", "Sainthamaruthu", "Akkaraipattu", "Uhana", "Digamadulla"],
    "Trincomalee": ["Trincomalee", "Kinniya", "Mutur", "Kantale", "Kuchchaveli"]
  },
  "North Western": {
    "Kurunegala": ["Kurunegala", "Kuliyapitiya", "Narammala", "Wariyapola", "Pannala", "Maho", "Ibbagamuwa", "Alawwa", "Galgamuwa"],
    "Puttalam": ["Puttalam", "Chilaw", "Marawila", "Nattandiya", "Wennappuwa", "Anamaduwa", "Kalpitiya"]
  },
  "North Central": {
    "Anuradhapura": ["Anuradhapura", "Kekirawa", "Eppawala", "Mihintale", "Tambuttegama", "Medawachchiya", "Galenbindunuwewa"],
    "Polonnaruwa": ["Polonnaruwa", "Kaduruwela", "Hingurakgoda", "Medirigiriya", "Aralaganwila"]
  },
  "Uva": {
    "Badulla": ["Badulla", "Bandarawela", "Haputale", "Diyatalawa", "Welimada", "Mahiyanganaya", "Passara", "Ella"],
    "Moneragala": ["Moneragala", "Wellawaya", "Buttala", "Bibile", "Kataragama", "Medagama"]
  },
  "Sabaragamuwa": {
    "Ratnapura": ["Ratnapura", "Balangoda", "Embilipitiya", "Pelmadulla", "Kuruwita", "Eheliyagoda", "Rakwana"],
    "Kegalle": ["Kegalle", "Mawanella", "Warakapola", "Rambukkana", "Aranayaka", "Deraniyagala", "Dehiowita"]
  }
};